<template>
  <div>
    <status-bar :status="status"></status-bar>
    <div class="container" v-if="status == 8 || status == 9">
      <img src="../../assets/ico_submit.png" />
      <p class="title">报名信息已提交，审核中… </p>
      <p class="msg">您的报名信息已提交至当地分公司</p>
      <p class="msg">我们会尽快与您取得联系，请耐心等</p>
    </div>
    <div class="container" v-else>
      <img src="../../assets/ico_smile.png" />
      <p class="title">请您按时参加面试，感谢您的关注！ </p>
      <div class="interview_msg">
        <img src="../../assets/info_left.png" />
        <span>面试信息</span>
        <img src="../../assets/info_right.png" />
      </div>
      <div class='address'>
        <ul>
          <li>时间：</li>
          <li>{{ datas.date_desc }} {{ datas.hour_span }}</li>
        </ul>
        <ul>
          <li>考点：</li>
          <li>{{ datas.name }}</li>
        </ul>
        <ul>
          <li>地址：</li>
          <li>{{ datas.address }}</li>
        </ul>
        <ul>
          <li>备注：</li>
          <li class="tips">请携带本人身份证及驾驶证原件</li>
        </ul>
      </div>
    </div>
    <div class="default-info" v-if="defaultInfo.phone||defaultInfo.address">
      <div v-if="defaultInfo.phone">如有疑问请联系当地分公司：<span>{{ defaultInfo.phone }}</span></div>
      <div v-if="defaultInfo.address">联系地址：{{ defaultInfo.address }}</div>
    </div>
    <div class="default-info" v-else>
      <div class="tips">
          {{defaultInfo.default_text}}<span>{{defaultInfo.default}}</span>
        </div>
    </div>
  </div>
</template>
<script>
import { getCompanyInfo, getSignUpInfo } from '../../utils/actions'
import statusBar from '@/components/StatusBar'
import { changeHistory } from '../../utils/common.js'
export default {
  data () {
    return {
      status: '',
      datas: {},
      defaultInfo: {}
    }
  },
  components: {
    statusBar
  },
  created () {
    this.status = this.$route.params.status
    this.getSignUpInfo()
    changeHistory()
  },
  methods: {
    async getSignUpInfo () {
      let _this = this
      let data = await getSignUpInfo({
        id: _this.$store.state.id,
        open_id: _this.$store.state.openid
      })
      if (data && data.data) {
        _this.datas = data.data.interview_booking
        if (data.data.id_card) {
          this.$store.commit('IDCAR', data.data.id_card)
        }
        let status = data.data.status
        if (status === '12') {
          this.$router.push({name: 'appointedRoadTest', params: {status: data.data.status}})
        }
      }
      getCompanyInfo({
        city_id: this.$store.state.cityId || '1'
      }).then((res) => {
        this.defaultInfo = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  text-align: center;
  margin-top: 1.36rem;
  font-size: .28rem;

  img {
    height: auto;
    width: 1.32rem;
  }

  .msg {
    font-size: .24rem;
  }

  .title {
    margin: .2rem 0;
  }
}

.interview_msg {
  margin: .6rem 0 .42rem 0;

  img {
    width: .98rem;
    height: auto;
    vertical-align: bottom;
    padding-bottom: .09rem;
  }

  span {
    font-size: .28rem;
    color: #323233;
    margin: 0 .28rem;
  }
}

.address {
  width: 90%;
  margin-left: 5%;

  ul li:first-child {
    max-width: 20%;
    text-align: right;
    float: left;
    width: 1.4rem;
  }

  ul li:last-child {
    width: 75%;
    text-align: left;
    float: left;
  }

  li {
    display: inline-block;
  }

  ul {
    line-height: .44rem;
  }

  ul:after {
    content: '';
    display: block;
    clear: both;
  }
}

.default-info {
  position: fixed;
  bottom: .4rem;
  left: 0;
  right: 0;
  width: 95%;
  margin: 0 auto;
  text-align: center;
  color: #19191A;
  line-height: .34rem;
  font-size: .24rem;

  div {
    span {
      color: #2A2AFF;
    }
  }
  .tips {
  text-align: center;
  font-size: .24rem;
  font-weight: 400;
  color: #19191A;
  line-height: .34rem;
  span {
    color: #2A2AFF;
  }
}
}
</style>



// WEBPACK FOOTER //
// src/pages/msg-audit/index.vue